import React, { createContext, useContext, useState, useCallback } from "react";
import ar from "../i18n/ar.json";
import en from "../i18n/en.json";
import tr from "../i18n/tr.json";

const translations = { AR: ar, EN: en, TR: tr };

/** Detect browser/phone language and map to AR | EN | TR */
function detectBrowserLanguage() {
  const browserLang = (
    navigator.language ||
    navigator.userLanguage ||
    ""
  ).toLowerCase();

  if (browserLang.startsWith("ar")) return "AR";
  if (browserLang.startsWith("tr")) return "TR";
  if (browserLang.startsWith("en")) return "EN";

  // Default fallback
  return "AR";
}

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectBrowserLanguage);

  const t = useCallback(
    (key) => {
      const keys = key.split(".");
      let value = translations[lang];
      for (const k of keys) {
        if (value == null) return key;
        value = value[k];
      }
      return value ?? key;
    },
    [lang]
  );

  const dir = translations[lang]?.dir || "rtl";

  return (
    <I18nContext.Provider value={{ lang, setLang, t, dir }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
